import { render, staticRenderFns } from "./CreateEditQuizModal.vue?vue&type=template&id=33e0c8cc&scoped=true&"
import script from "./CreateEditQuizModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditQuizModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateEditQuizModal.vue?vue&type=style&index=0&id=33e0c8cc&prod&lang=css&"
import style1 from "./CreateEditQuizModal.vue?vue&type=style&index=1&id=33e0c8cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e0c8cc",
  null
  
)

export default component.exports